import { createAction, props } from '@ngrx/store';

export const gcSpCommitmentsViewContractComponentActions = {
  loadPage: createAction(
    '[PSP/SP Commitments View Contract Component] Load Page',
    props<{ contractId: number }>(),
  ),
};
